import { LogCategory, TraceLevel } from "@1js/office-online-jsapi-core";
import type { DocumentBootInfo } from "../../types";
import { Action } from "../../types";

import type { BaseHandlerParams } from "../types";
import {
  bootApplication,
  endSessionFromHost,
} from "../../bootApplicationFromUiHost";

export interface RebootHandlerParams extends BaseHandlerParams {
  newDocBootUrl: string;
  rebootReason?: string;
  rebootMode?: string;
}

// This function will handle both reboot and create new scenarios
export async function rebootDocumentHandler({
  documentBootInfo,
  sessionConfig,
  uiHostConfig,
  getAuthToken,
  container,
  eventHandlers,
  logger,
  newDocBootUrl,
  rebootReason,
  rebootMode,
}: RebootHandlerParams): Promise<any> {
  // No document boot url also indicates a mode switch
  logger?.ULS.sendTraceTag(
    0x1e30a70b /* tag_4mk2l */,
    LogCategory.msoulscat_Wac_UnifiedUiHost,
    TraceLevel.Info,
    `Calling reboot handler. Reason: ${rebootReason}`
  );
  await endSessionFromHost();

  const rebootDocInfo: DocumentBootInfo = {
    sourceDoc: newDocBootUrl ? undefined : documentBootInfo.sourceDoc, // if no newDocBootUrl, then it's a mode switch (same doc)
    docTenantUrl: newDocBootUrl ? undefined : documentBootInfo.docTenantUrl, // if no newDocBootUrl, then it's a mode switch (same doc)
    shareUrl: newDocBootUrl,
    hostingPageOrigin: documentBootInfo.hostingPageOrigin,
    action: rebootMode === "view" ? Action.View : Action.Default,
    isNewDoc: rebootReason === "createNew",
  };

  return await bootApplication({
    documentBootInfo: rebootDocInfo,
    sessionConfig,
    uiHostConfig,
    getAuthToken,
    eventHandlers,
    container,
  });
}
